import React from 'react';
import '../css/Testimonials.css';

const quotes = [
  { text: 'Onur delivered our MVP in record time with zero prod bugs.',
    name: 'Daria Kataev', role: 'CTO · Sword Garage' },
  { text: 'Rare blend of speed, clean code and UX instinct.',
    name: 'Seda İlhan', role: 'Product Lead · Koyuncu Elektronik' },
  { text: 'His React + Flask expertise turned legacy chaos into scale.',
    name: 'Imran B.', role: 'Founder · TrioTech' },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="testimonials">
      <h2 className="testimonials-title">Testimonials</h2>

      <div className="testimonial-grid">
        {quotes.map((q,i)=>(
          <blockquote className="testimonial-card" key={i}>
            <p>“{q.text}”</p>
            <footer><strong>{q.name}</strong><span> — {q.role}</span></footer>
          </blockquote>
        ))}
      </div>
    </section>
  );
}
